<template>
  <div class="my-3">
    <label>Start With</label>
    <div class="border">
      <div class="row p-3">
        <div class="col-sm-4 col-md-4">
          <router-link
            :to="{
              name: 'AdminAddPointsSelectPrograms',
            }"
            >Select A Program/Contest</router-link
          >
        </div>
        <div class="col-sm-4 col-md-4">
          <router-link
            :to="{
              name: 'AdminPointProgramsNewProgramContest',
            }"
            >Add New Program/Contest</router-link
          >
        </div>
        <div class="col-sm-4 col-md-4">
          <a href="/point-programs/list">Manage Program/Contest</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddPointsStartWith',

  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
